import setLang from '../lang';

const lang = {
    i: {
        locale: 'sv-SE',
        select: {
            placeholder: 'Välj',
            noMatch: 'Ingen träff',
            loading: 'Laddar'
        },
        table: {
            noDataText: 'Ingen data',
            noFilteredDataText: 'Ingen filter data',
            confirmFilter: 'Bekräfta',
            resetFilter: 'Återställ filter',
            clearFilter: 'Rensa filter'
        },
        datepicker: {
            selectDate: 'Välj datum',
            selectTime: 'Välj tidpunkt',
            startTime: 'Start tid',
            endTime: 'Slut tid',
            clear: 'Rensa',
            ok: 'Ok',
            datePanelLabel: '[mmmm] [yyyy]',
            month: 'Månad',
            month1: 'Januari',
            month2: 'Februari',
            month3: 'Mars',
            month4: 'April',
            month5: 'Maj',
            month6: 'Juni',
            month7: 'Juli',
            month8: 'Augusti',
            month9: 'September',
            month10: 'Oktober',
            month11: 'November',
            month12: 'December',
            year: 'År',
            weekStartDay: '1',
            weeks: {
                sun: 'Sön',
                mon: 'Mån',
                tue: 'Tis',
                wed: 'Ons',
                thu: 'Tor',
                fri: 'Fre',
                sat: 'Lör'
            },
            months: {
                m1: 'Jan',
                m2: 'Feb',
                m3: 'Mar',
                m4: 'Apr',
                m5: 'Maj',
                m6: 'Jun',
                m7: 'Jul',
                m8: 'Aug',
                m9: 'Sep',
                m10: 'Okt',
                m11: 'Nov',
                m12: 'Dec'
            }
        },
        transfer: {
            titles: {
                source: 'Källa',
                target: 'Mål'
            },
            filterPlaceholder: 'Sök här',
            notFoundText: 'Hittade inte'
        },
        modal: {
            okText: 'Ok',
            cancelText: 'Avbryt'
        },
        poptip: {
            okText: 'Ok',
            cancelText: 'Avbryt'
        },
        page: {
            prev: 'Föregående sida',
            next: 'Nästa sida',
            total: 'Totalt',
            item: 'objekt',
            items: 'objekt',
            prev5: 'Föregående 5 sidor',
            next5: 'Nästa 5 sidor',
            page: '/page',
            goto: 'Gå till',
            p: ''
        },
        rate: {
            star: 'Stjärna',
            stars: 'Stjärnor'
        },
        tree: {
            emptyText: 'Ingen data'
        }
    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./src/locale/lang/sv-SE.js